import script from "./DownloadlistBlock.vue?vue&type=script&lang=js"
export * from "./DownloadlistBlock.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__